export const baseUrl = `${process.env.REACT_APP_URL}/api`
// export const baseUrl = `${'http://46.101.187.66:4000'}/api`

// export default baseUrl